<section class="container">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3 class="text-success m-0">Edição de programa permitido por cesta</h3>
    <div class="d-flex">
      <button type="button" class="btn btn-danger me-2" (click)="voltar()">Voltar</button>
      <button type="button" class="btn btn-success" (click)="salvar()">Salvar</button>
    </div>
  </div>

  <div class="row" *ngIf="programa">
    <div class="col-3">
      <label class="form-label d-block">Código</label>
      <input type="text" class="form-control" [value]="codigoFormatado" disabled>
    </div>
    <div class="col-5">
      <label class="form-label d-block">Descrição do programa</label>
      <input type="text" class="form-control" [value]="programa.descricaoPrograma" disabled>
    </div>
    <div class="col-4">
      <div class="d-flex justify-content-start" style="gap: 2.5rem;">
        <div class="d-flex flex-column align-items-center">
          <label class="form-label text-nowrap">Aceita PF</label>
          <input type="checkbox" class="form-check-input m-0" [(ngModel)]="programa.aceitaBeneficiarioCpfRepasse">
        </div>
        <div class="d-flex flex-column align-items-center">
          <label class="form-label text-nowrap">Desconsiderar Prazo</label>
          <input type="checkbox" class="form-check-input m-0" [(ngModel)]="programa.desconsiderarPrazoTotalMaximoContratual">
        </div>
      </div>
    </div>
  </div>
</section>
